import { combineReducers } from "redux";
import chatsReducer from "./chats/chats.reducer";
import authReducer from "./auth/auth.reducer";
import connectionReducer from "./connection/connection.reducer";
import voiceMsgReducer from "./voice/voice.reducer";
import userReducer from "./user/user.reducer";
import settingsReducer from "./settings/settings.reducer";
import roadmapReducer from "./roadmap/roadmap.reducer";
import generalDataReducer from "./general-data/general-data.reducer";
import cacheReducer from "./cache/cache.reducer";

const rootReducer = combineReducers({
  chatsData: chatsReducer,
  authData: authReducer,
  connectionData: connectionReducer,
  voiceMsgData: voiceMsgReducer,
  userData: userReducer,
  settingsData: settingsReducer,
  roadmapData: roadmapReducer,
  generalData: generalDataReducer,
  cacheData: cacheReducer,
});

export default rootReducer;
